/*
 * Copyright (C) 2020 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { ObservableResult } from '../../store';
import { LikeInfoDataService } from './like-info-data.service';

@Injectable()
export class MockLikeInfoDataService implements LikeInfoDataService {
  votePlaylist(playlistUid: string): ObservableResult<number> {
    return ObservableResult.ofSuccess(100);
  }

  unvotePlaylist(playlistUid: string): ObservableResult<number> {
    return ObservableResult.ofSuccess(100);
  }

  voteResource(resourceUid: string): ObservableResult<number> {
    return ObservableResult.ofSuccess(100);
  }

  unvoteResource(resourceUid: string): ObservableResult<number> {
    return ObservableResult.ofSuccess(100);
  }

  likeMoment(momentUid: string): ObservableResult<number> {
    return ObservableResult.ofSuccess(100);
  }

  unlikeMoment(momentUid: string): ObservableResult<number> {
    return ObservableResult.ofSuccess(100);
  }
}
